import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule,  provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoggerModule } from 'ngx-logger';

import { LOGGER_CONFIG } from 'src/app/shared/configuration/loggerConfig';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { LeftNavigationComponent } from './components/left-navigation/left-navigation.component';
import { CoreModule } from './core/core.module';
import { Globals } from './shared/configuration/globals';
import { getFRPaginatorIntl } from './shared/configuration/matPaginatorFR';
import { SharedModule } from './shared/shared.module';
import { DisplayErrorsMessageModule } from './tinea-components/display-errors-message/display-errors-message.module';
import { CommonBaseModule } from './tinea-components/okta/common-base.module';
import { ExportMobileModuleModule } from './modules/mobile/modules/export-mobile-module/export-mobile-module.module';

import {WebModule} from '../swagger-gen/lng/web.module';
import { environment } from 'src/environments/environment';

import moment from 'moment';
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {CUSTOM_DATE_FORMATS} from "./shared/configuration/date-formats";

moment.locale('fr');
registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LeftNavigationComponent
  ],
  imports: [
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({}),
      fallbackLang: 'fr', // this language will be used as a fallback when a translation isn't found in the current language
    }),
    TranslateModule,
    MatTableModule,
    SharedModule,
    // OktaModule,
    FormsModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    HttpClientModule,
    LoggerModule.forRoot(LOGGER_CONFIG),
    CoreModule,
    CommonBaseModule,
    DisplayErrorsMessageModule,
    FormsModule,
    MatProgressSpinnerModule,
    BrowserModule,
    BrowserAnimationsModule,
    ExportMobileModuleModule,
    AppRoutingModule, // this one should ALWAYS be the last!
    WebModule.forRoot({rootUrl: environment.apiUrl})
  ],
  providers: [
    /*  Globals: have to be provided only here at the top level,
    as it's a singleton which values can be changed by another service */
    Globals,
    Title,
    DatePipe,
    { provide: MatPaginatorIntl, useValue: getFRPaginatorIntl() },
    { provide: MAT_DATE_LOCALE, useValue: 'fr' },
    provideMomentDateAdapter(CUSTOM_DATE_FORMATS),
    provideZoneChangeDetection({ eventCoalescing: true })
  ],
  bootstrap: [AppComponent],
  exports: [
    BrowserAnimationsModule,
    BrowserModule,
  ],
})
export class AppModule {
  // for i18n datepipes
  constructor() {
    registerLocaleData(localeFr);
  }
}
